/* eslint-disable jsx-a11y/anchor-is-valid */

import {CustomProvider} from 'rsuite'
import ptBR from 'rsuite/locales/pt_BR'
import {DashboardProvider} from '../../../contexts/kpi/dashboard'
import {Dashboard} from './Dashboard'

export const DashboardPage = () => {
  return (
    <DashboardProvider>
      <CustomProvider locale={ptBR}>
        <Dashboard />
      </CustomProvider>
    </DashboardProvider>
  )
}
